import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { trackHamburgerClick } from './site-header.analytics';

import { Search, MyTraderaMenu } from 'components';

import isTouch from 'core/utils/is-touch';
import breakpoints from 'core/utils/breakpoints';

const isTouchDevice = isTouch();
const isTouchWithTabletSize =
    breakpoints.isVisible(breakpoints.siteheaderportrait) && isTouchDevice;

class SiteHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hoverUser: false,
            showSearch: props.initData.hasSearch // TODO check initData.pageName ..
        };
    }

    handleClickSearch = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                showSearch: !prevState.showSearch
            };
        });
    };

    handleMouseOverUser = () => {
        if (!isTouchDevice) {
            // IF not needed since Touch-devices cant hover? Verify when reacts event is triggered
            this.setState(prevState => {
                return {
                    ...prevState,
                    hoverUser: true
                };
            });
        }
    };

    handleMouseOutUser = () => {
        if (!isTouchDevice) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    hoverUser: false
                };
            });
        }
    };

    handleClickUser = evt => {
        if (!isTouchWithTabletSize) {
            return;
        }

        evt.preventDefault();
        this.setState(prevState => {
            return {
                ...prevState,
                hoverUser: !prevState.hoverUser
            };
        });
    };

    handleHamburgerClick = () => {
        const event = new Event('ui:site-header:on-hamburger-click');
        document.dispatchEvent(event);
        trackHamburgerClick();
    };

    render() {
        const { initData, cartItems, cartSum, publishEvent } = this.props;

        const {
            isLoggedIn,
            memberId,
            memberAlias,
            cleanedMemberAlias,
            searchQuery,
            searchParams,
            searchUrl
        } = initData;

        const showKlarnaMenu =
            initData.PaymentSettings && initData.PaymentSettings.ShowKlarnaMenu
                ? initData.PaymentSettings.ShowKlarnaMenu
                : false;
        const formattedCartItems = parseInt(cartItems, 10);

        return (
            <header className="slim-header container-fluid bp">
                <div
                    className="row align-items-center slim-header__content"
                    role="banner">
                    <div className="slim-header__logo col-auto order-1">
                        <a href="/" className="slim-header__logo-link">
                            <svg
                                data-nav-logo
                                alt="Tradera"
                                viewBox="0 0 489 96.4"
                                width="125"
                                height="35">
                                <path
                                    d="M34.6 0c2 0 1.5 2.3 1.5 2.3L32 32.4h17c1.6 0 1.6 1.8 1.6 1.8s-1.4 11.3-1.7 13.4c-.3 2.1-2 2.2-2 2.2h-17s-.5 3.3-2.2 16.2c-1.7 12.9 9.9 11.9 9.9 11.9 13.5.2 21-15.6 21-15.6 1.2-2.3 1.4-4.7 1.4-4.7s2.6-21.4 2.9-23.9c.3-2.5 2.1-2.4 2.1-2.4h15.3c1.8 0 1.6 1.8 1.6 1.8l-.9 7.4 3.4-3.9c5.3-5.8 14.1-8.9 21.1-4.4 7 4.5 3.7 13.8 3.7 13.8 2.5 3 6.7 1.5 12.4-4.2s13.9-11.7 26.6-12.3c12.7-.5 19.4 9.2 19.4 9.2s.5-3.9.7-5.5c.2-1.6 2-1.8 2-1.8h15.3c1.8 0 1.5 2.2 1.5 2.2s-4.2 34.6-4.7 39.1 2.3 5.8 2.3 5.8c4.6 2.6 10.7-1.8 10.7-1.8s-2.5-12.6 1.4-23c3.9-10.3 13.3-22.2 30.1-23.6s22.5 9.1 22.5 9.1 4.3-35.8 4.5-37.4c.2-1.6 2-1.8 2-1.8h15.3c1.7 0 1.6 1.8 1.6 1.8l-8.6 71.1c-.4 3.3 1.7 5.2 1.7 5.2 4.7 3.6 11.8-1.5 11.8-1.5-4.9-15.2 3.5-28.3 3.5-28.3C292.7 29.2 314 29.7 314 29.7c17.8 0 25.9 13.5 25.9 13.5 1.6 2.2.9 3.6.1 4.3-.3.3-36.7 29.9-36.7 29.9 27.9 10.3 48.1-25.1 48.8-27.4.7-2.3 2-14.6 2.2-16.6.2-2 2-2.1 2-2.1h15.3c1.9 0 1.5 2 1.5 2l-.9 7.1c3.9-6 14.4-13.4 23.1-9.2 8.6 4.2 5.3 14.3 5.3 14.3 3.4 4.6 9.8-1.6 9.8-1.6 30.5-29.2 48.4-5.4 48.4-5.4s.4-3.4.7-5.5c.3-2.1 2.6-1.8 2.6-1.8h14.4c2.3 0 1.8 2.2 1.8 2.2s-4.8 39.5-4.9 40.6c-.1 1.1 1 4.3 3.4 4.7 2.4.4 5.4-1.2 7-5.1 1.8-4.1 3.9-.3 3.9-.3 4.5 9.1-2.3 21.8-15.6 22.8s-17-11.5-17-11.5c-12.4 16.6-31.4 10.3-31.4 10.3-26.9-9-17.1-38.9-17.1-38.9-5.4 6.4-19 13.4-25.4 7.2-6.1-5.9-1.8-12.9-1.8-12.9-9.5 2.8-10.4 15-10.4 15s-2.7 22.4-3.1 26.2c-.4 3.7-2.9 3.2-2.9 3.2h-14.1c-2.6 0-1.8-3.2-1.8-3.2l1.8-15.2c-3.6 5.9-15.6 19.9-38.5 19.9-19.6 0-26.9-9.8-26.9-9.8s-10.7 9.8-23.3 9.8c-12.6 0-14.8-11.7-14.8-11.7s-9.5 11.7-24.2 11.7-20.7-9.1-20.7-9.1-10.4 9.1-21.9 9c-11.5-.1-14.8-11.3-14.8-11.3-9.8 13.3-25.1 11.3-25.1 11.3-35-3.2-23.8-40.1-23.8-40.1-4.1 5.6-17.1 12.9-24.5 7.9-7.4-5-2.9-13.3-2.9-13.3-3.2.6-7.6 6.1-8.6 9.4-1 3.3-4.3 32.1-4.3 32.1-.3 2.8-2.1 2.6-2.1 2.6H57.7c-2.7 0-2-2.4-2-2.4L57 81.6s-7.4 14.3-30.2 14.3c-22.8 0-19.3-23-19.3-23l3-23.1H1.9c-2.1 0-1.8-2-1.8-2S1.7 35.7 1.9 34C2 32.4 4 32.4 4 32.4h8.7s4-28.7 4.3-30.7c.3-2 2.4-1.8 2.4-1.8h7.5c-.1.1 5.7.1 7.7.1zm124.1 47.8c-4.6-3.6-19.2-4.3-24.8 11.2-5.6 15.4 8.5 24 17.8 20.8 9.3-3.2 11.7-10.2 11.7-10.2l1.6-13c-.7-2.9-2.4-5.7-6.3-8.8zm81.7 0c-4.6-3.6-19.2-4.3-24.8 11.2-5.6 15.4 8.5 24 17.8 20.8 9.3-3.2 11.7-10.2 11.7-10.2l1.6-13c-.7-2.9-2.3-5.7-6.3-8.8zm209.6 0c-4.6-3.6-19.2-4.3-24.8 11.2-5.6 15.4 8.5 24 17.8 20.8 9.3-3.2 11.7-10.2 11.7-10.2l1.6-13c-.7-2.9-2.3-5.7-6.3-8.8zM294.8 68l23.5-19.8s-7.2-6.4-17.2.9c-10 7.4-6.3 18.9-6.3 18.9z"
                                    fill="#2e3841"
                                />
                            </svg>
                        </a>
                    </div>
                    <div
                        className={`slim-header__search col-12 order-3 order-md-2 col-md-auto d-none d-md-flex ${
                            this.state.showSearch ? 'd-flex' : ''
                        }`}
                        id="slim-header__search">
                        <Search
                            initData={initData}
                            searchTerm={searchQuery}
                            searchParams={searchParams}
                            searchUrl={searchUrl}
                            publishEvent={publishEvent}
                        />
                    </div>
                    <nav
                        className="slim-header__menu col-auto order-2 order-md-3 justify-content-end"
                        role="navigation">
                        <ul className="slim-header__menu-list row justify-content-end">
                            <li className="slim-header__menu-option d-none d-md-flex align-items-center">
                                <a
                                    href="/kategorier"
                                    aria-label="Kategorier"
                                    className="slim-header__menu-link slim-header__menu-link--categories px-3 d-flex align-items-center"
                                    title="Kategorier"
                                    data-ga-category="Header"
                                    data-ga-action="Navigation"
                                    data-ga-label="Categories"
                                    data-nav-category>
                                    <svg
                                        viewBox="0 0 30 30"
                                        width="22"
                                        height="20">
                                        <path
                                            d="M29.896 8.785c.07.162.104.359.104.59v18.75c0 .51-.185.95-.556 1.32-.37.37-.81.555-1.319.555H1.875c-.51 0-.95-.185-1.32-.556-.37-.37-.555-.81-.555-1.319V9.375c0-.231.035-.428.104-.59l2.5-7.5a1.77 1.77 0 0 1 .677-.92C3.617.122 3.981 0 4.375 0h21.25c.394 0 .758.122 1.094.365.335.243.561.55.677.92l2.5 7.5zm-26.042.59h22.292L24.27 3.75H5.729L3.854 9.375z"
                                            fill="#2D3742"
                                            fillRule="evenodd"
                                        />
                                    </svg>
                                    <span className="slim-header__link-text d-none d-lg-inline bold">
                                        Kategorier
                                    </span>
                                </a>
                            </li>
                            <li className="slim-header__menu-option d-none d-md-flex align-items-center">
                                <a
                                    href="/selling"
                                    aria-label="Skapa annons"
                                    className="slim-header__menu-link px-3 d-flex align-items-center"
                                    title="Skapa annons"
                                    data-ga-category="Header"
                                    data-ga-action="Navigation"
                                    data-ga-label="SYI"
                                    data-nav-syi>
                                    <svg
                                        viewBox="0 0 30 30"
                                        width="22"
                                        height="20">
                                        <path
                                            d="M18.125 30h-6.25a.61.61 0 0 1-.451-.174.61.61 0 0 1-.174-.451V18.75H.625a.61.61 0 0 1-.451-.174.61.61 0 0 1-.174-.451v-6.25a.61.61 0 0 1 .174-.451.61.61 0 0 1 .451-.174H11.25V.625a.61.61 0 0 1 .174-.451.61.61 0 0 1 .451-.174h6.25a.61.61 0 0 1 .451.174.61.61 0 0 1 .174.451V11.25h10.625a.61.61 0 0 1 .451.174.61.61 0 0 1 .174.451v6.25a.61.61 0 0 1-.174.451.61.61 0 0 1-.451.174H18.75v10.625a.61.61 0 0 1-.174.451.61.61 0 0 1-.451.174z"
                                            fill="#2D3742"
                                            fillRule="evenodd"
                                        />
                                    </svg>
                                    <span className="slim-header__link-text d-none d-lg-inline bold">
                                        Skapa annons
                                    </span>
                                </a>
                            </li>
                            <li className="slim-header__menu-option d-flex d-md-none align-items-center">
                                <button
                                    className="slim-header__search-button unbutton px-3 d-flex align-items-center"
                                    aria-label="Sök"
                                    onClick={this.handleClickSearch}
                                    data-nav-search-button
                                    aria-hidden="true">
                                    <svg
                                        viewBox="0 0 20 20"
                                        width="23"
                                        height="23">
                                        <path
                                            d="M17.3 15.7l-4.1-4.1c2.4-3 1.9-7.4-1.1-9.8s-7.5-2-9.9 1.1-1.9 7.4 1.1 9.8c2.1 1.7 5.1 2 7.5.8l4.3 4.3 2.2-2.1zM3.8 7.3c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4z"
                                            fill="#231f20"
                                        />
                                    </svg>
                                </button>
                            </li>
                            <li className="slim-header__menu-option d-flex align-items-center">
                                <a
                                    href="/my/wish-list"
                                    aria-label="Minneslista"
                                    className="slim-header__menu-link slim-header__menu-link--wishlist px-3 d-flex align-items-center"
                                    data-ga-category="Header"
                                    data-ga-action="Navigation"
                                    data-ga-label="Minneslistan"
                                    data-nav-wishlist>
                                    <svg
                                        viewBox="0 0 30 30"
                                        width="22"
                                        height="20">
                                        <path
                                            d="M25.859 15.66L15.477 26.076c-.162.116-.313.174-.452.174a.61.61 0 0 1-.451-.174L4.192 15.66c-1.62-1.62-2.772-3.264-3.455-4.93C.054 9.061-.154 7.522.112 6.11s.932-2.65 1.997-3.715C3.683.822 5.592.035 7.838.035c2.245 0 4.155.787 5.729 2.36a8.55 8.55 0 0 1 1.458 1.945 8.55 8.55 0 0 1 1.459-1.944C18.058.799 19.967 0 22.213 0c2.245 0 4.166.799 5.764 2.396C29.04 3.46 29.7 4.699 29.956 6.11c.254 1.412.04 2.951-.643 4.618-.682 1.667-1.834 3.31-3.454 4.93z"
                                            fill="#2D3742"
                                            fillRule="evenodd"
                                        />
                                    </svg>

                                    <span className="slim-header__link-text d-none d-lg-inline bold">
                                        Minneslista
                                    </span>
                                </a>
                            </li>
                            <li className="slim-header__menu-option slim-header__menu-option-divider d-flex align-items-center">
                                <a
                                    href="/my/overview"
                                    aria-label="Mitt Tradera"
                                    className="slim-header__menu-link slim-header__menu-link--user px-3 d-flex align-items-center"
                                    data-ga-category="Header"
                                    data-ga-action="Navigation"
                                    data-ga-label="My Tradera"
                                    title={
                                        isLoggedIn ? memberAlias : 'Logga in'
                                    }
                                    onMouseOver={this.handleMouseOverUser}
                                    data-nav-mytradera
                                    onMouseOut={this.handleMouseOutUser}
                                    onClick={this.handleClickUser}>
                                    <span className="row d-flex align-items-center align-items-center no-gutters">
                                        <svg
                                            viewBox="0 0 30 30"
                                            width="22"
                                            height="20">
                                            <path
                                                d="M30 28.125v1.25a.61.61 0 0 1-.174.451.61.61 0 0 1-.451.174H.625a.61.61 0 0 1-.451-.174.61.61 0 0 1-.174-.451v-1.25c0-1.157.388-2.135 1.163-2.934.776-.799 1.713-1.424 2.813-1.875 1.1-.451 2.199-.88 3.298-1.285 1.1-.405 2.037-.931 2.813-1.58.775-.648 1.163-1.423 1.163-2.326a10.339 10.339 0 0 1-.4-.434c-.173-.197-.474-.637-.902-1.32a16.79 16.79 0 0 1-1.146-2.17c-.336-.764-.636-1.753-.903-2.968C7.633 10.017 7.5 8.773 7.5 7.5c0-2.06.735-3.825 2.205-5.295C11.175.735 12.94 0 15 0s3.825.735 5.295 2.205C21.765 3.675 22.5 5.44 22.5 7.5c0 1.273-.127 2.512-.382 3.715-.255 1.204-.567 2.205-.937 3.004-.37.798-.741 1.504-1.112 2.118-.37.613-.682 1.07-.937 1.371l-.382.417c0 .903.388 1.678 1.163 2.326.776.649 1.713 1.175 2.813 1.58s2.199.834 3.298 1.285c1.1.451 2.037 1.076 2.813 1.875.775.799 1.163 1.777 1.163 2.934z"
                                                fill="#2D3742"
                                                fillRule="evenodd"
                                            />
                                        </svg>
                                        {isLoggedIn ? (
                                            <span className="slim-header__link-text pl-1 d-none d-lg-inline col-auto">
                                                {memberAlias}
                                            </span>
                                        ) : null}
                                        <span
                                            className="slim-header__user-menu-icon arrow-down--after ss-fix--after pl-1 col-auto d-none d-md-inline"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </a>
                                <MyTraderaMenu
                                    hoverUser={this.state.hoverUser}
                                    showKlarnaMenu={showKlarnaMenu}
                                    cleanedMemberAlias={cleanedMemberAlias}
                                    memberId={memberId}
                                    isLoggedIn={isLoggedIn}
                                />
                            </li>
                            {formattedCartItems > 0 ? (
                                <li className="slim-header__menu-option d-none d-md-flex align-items-center">
                                    <a
                                        href="/Shopping/CartOverview"
                                        aria-label="Mitt Tradera"
                                        data-ga-category="Header"
                                        data-ga-action="Navigation"
                                        data-ga-label="Cart with items"
                                        className="slim-header__cart-link">
                                        Varukorg: {formattedCartItems}st<br />
                                        <span className="bold">
                                            {cartSum} kr
                                        </span>
                                    </a>
                                </li>
                            ) : null}
                            <li className="slim-header__menu-option d-flex d-md-none align-items-center">
                                <button
                                    aria-label="Meny"
                                    className="slim-header__menu-link unbutton px-3"
                                    onClick={this.handleHamburgerClick}>
                                    {formattedCartItems > 0 ? (
                                        <span className="slim-header__notification">
                                            {formattedCartItems}
                                        </span>
                                    ) : null}
                                    <span
                                        className="slim-header__nav-icon hamburger-icon"
                                        aria-hidden="true">
                                        <i />
                                    </span>
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        );
    }
}

SiteHeader.propTypes = {
    initData: PropTypes.object.isRequired,
    cartItems: PropTypes.string
};

export default SiteHeader;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/site-header.jsx